import { ChangeDraftVm } from '@/features/dashboard/bookingChanges/types/ChangeViewModel.ts';
import { pluralForm } from '@/utils/pluralize.ts';
import { formatSignedMoneyList } from '@/features/dashboard/bookingChanges/utils/formatters.ts';
import { pluralizeItems } from '@/features/dashboard/bookingChanges/utils/plurals.ts';

/**
 * Zdania modala kończącego edycję.
 *
 * Liczby pochodzą ze szkicu, nie z projektu, więc odmiana musi być policzona,
 * a nie wpisana: „1 pozycja przepada”, „2 pozycje przepadają”, „5 pozycji
 * przepada”. Słowa niesie `utils/plurals.ts`, regułę `@/utils/pluralize.ts`.
 */

/** „W szkicu jest 5 pozycji na + 240,00 zł. Nic z tego nie działa, …”. */
export const buildExitEditingSummary = (draft: ChangeDraftVm): string => {
  const verb = pluralForm(draft.itemCount, 'jest', 'są', 'jest');

  return `W szkicu ${verb} ${pluralizeItems(draft.itemCount)} na ${formatSignedMoneyList(
    draft.totalDelta,
  )}. Nic z tego nie działa, dopóki nie wprowadzisz paczki.`;
};

/** Dopisek przycisku odrzucenia — „5 pozycji przepada”. */
export const buildDiscardHint = (itemCount: number): string =>
  `${pluralizeItems(itemCount)} ${pluralForm(itemCount, 'przepada', 'przepadają', 'przepada')}`;
